import MainWrapper from "../MainWrapper";

const ComingSoon = () => {
  return (
    <MainWrapper>
      <div style={{ display: "grid", placeItems: "center", height: "100%" }}>
        <img src="/coming-soon.gif" alt="" className="img-fluid" />
        <div className="display-3">Coming Soon !!!</div>
        <p className="lead"> Watch this space</p>
      </div>
    </MainWrapper>
  );
};

export default ComingSoon;
